import { userInfoEdit, getWallet } from '@api/mine';
import { Toast } from 'mand-mobile';
import router from '../../router';

const userInfo = (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))) || {};

const state = {
  userInfo,
  token: localStorage.getItem('token') || '',
  walletInfo: {
    balance: '0.00',
    income: '0.00'
  }
};

const mutations = {
  setUserInfo: (state, data) => {
    if (JSON.stringify(data) === '{}') {
      state.userInfo = data;
    } else {
      state.userInfo = { ...state.userInfo, ...data };
    }
    localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
  },
  setToken: (state, data) => {
    state.token = data;
    localStorage.setItem('token', data);
  },
  setWalletInfo: (state, data) => {
    state.walletInfo = data;
  }
};

const actions = {
  userInfoEdit ({ commit }, params) {
    const mapObj = {
      1: 'nick_name',
      2: 'introduction',
      3: 'gender',
      4: 'birthday',
      5: 'address',
      6: 'phone',
      7: 'email'
    };
    userInfoEdit(params).then(res => {
      if (res.result === 200000) {
        Toast.succeed(res.msg);
        const editData = {};
        editData[mapObj[params.type]] = params.content;
        commit('setUserInfo', editData);

        const fromRoute = localStorage.getItem('fromRoute');
        if (['/userInfoEdit', '/accountSafe'].includes(fromRoute)) {
          router.push(fromRoute);
        }
      } else {
        Toast.failed(res.msg);
      }
    }).catch(() => {
      Toast.failed('修改失败');
    });
  },
  getWalletInfo ({ commit }) {
    getWallet().then(res => {
      if (res.result === 200000) {
        commit('setWalletInfo', res.data.info);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
